import { AxiosInstance } from "axios";
import { IEventDay } from "../interfaces/IEventDay";

export class EventDayService {
    private apiClient: AxiosInstance;
    private endpoint: string;
    constructor(apiClient: AxiosInstance) {
        this.apiClient = apiClient;
        this.endpoint = '/admin/event-day';
    }

    async getAll(eventId: string): Promise<IEventDay[]> {
        try {
            const response = await this.apiClient.get(`${this.endpoint}/${eventId}`);
            return response.data;
        } catch (error: any) {
            throw new Error(error.response ? error.response.data : 'An error occurred');
        }
    }

    async get(eventId: string, id: string): Promise<IEventDay> {
        try {
            const response = await this.apiClient.get(`${this.endpoint}/${eventId}/${id}`);
            return response.data;
        } catch (error: any) {
            throw new Error(error.response ? error.response.data : 'An error occurred');
        }
    }
}